export default __webpack_public_path__ + "static/media/06.66f24894.mp3";